export interface MissingExam {
    student_id: number,
    student_name: string,
    class_name: string,
    subject_id: number,
    subject_name: string,
    date: string,
    lessons: string,
    absence_type: string,
    written: boolean,
    written_on: string | null,
    written_separately: boolean,
    admitted: boolean,
    admittable: boolean, // See MissingExam::isAdmittable().
    missed_retakes: number,
    status: string,
    certificate_deadline: string | null,
}

export interface OpenExam {
    subject_id: number,
    subject_name: string,
    date: string,
    status: string,
    certificate_deadline: string | null,
    admitted: boolean,
}

export interface RetakeAssignment extends MissingExam {
    present: boolean | null,
    open_exams: Array<OpenExam>,
}

export interface RetakeDate {
    id: number,
    start: string | null,
    end: string | null,
    topic: string | null,
    all_day: boolean,
    underway: boolean,
    early_start_minutes: number,
}

// The absent types tblfehlzeiten stores, see Fehlzeiten::getAbsentTypeAttribute().
export const ABSENCE_TYPES: Record<string, { label: string, colour: string }> = {
    F: {label: 'Unentschuldigt', colour: 'red'},
    E: {label: 'Entschuldigt', colour: 'green'},
    K: {label: 'Krank', colour: 'green'},
}

// The values of MissingExamStatus; teachers see both ways of losing the retake as one.
export const STATUSES: Record<string, { label: string, colour: string }> = {
    pending: {label: 'Zugelassen', colour: 'green'},
    certificate_due: {label: 'Warten auf Attest', colour: 'orange'},
    written: {label: 'Nachgeschrieben', colour: 'green'},
    struck: {label: 'Nicht zugelassen', colour: 'red'},
    unexcused: {label: 'Nicht zugelassen', colour: 'red'},
}

// See MissingExamStatus::isAcknowledgeable().
export const isAcknowledgeable = (exam: MissingExam): boolean => ['unexcused', 'struck', 'written'].includes(exam.status)

// Identifies a missed exam like the backend does: student, subject, exam day.
export const examKey = (studentId: number, exam: OpenExam): string => `${studentId}|${exam.subject_id}|${exam.date}`
